const pushToDataLayer = window.BAO.Utils.pushToDataLayer

window.addEventListener('PLP-grid-view-changed', trackPlpGridChange)
window.addEventListener('filter-form-submit', trackFilters)
document.addEventListener('wishlist-item-added', trackAddToWishlist)
document.addEventListener('wishlist-item-removed', trackRemoveFromWishlist)
window.addEventListener('PDP-gallery-click', trackPdpGalleryClick)
window.addEventListener('PDP-gallery-thumbnail-click', trackPdpGalleryThumbClick)
window.addEventListener('pdp-colour-change', trackPDPColourChange)
window.addEventListener('pdp-variant-change', trackPDPVariantChange)
document.addEventListener('add-to-cart-quick-add', trackQuickAdd)

handleNavigationClick()

function trackPlpGridChange(event) {
  const parameters = {
    event_action: event.detail.selectedDisplay
  }

  pushToDataLayer('plp_grid_view', parameters)
}

function trackFilters (event) {
  const target = event.detail.target
  const targetContext = target.closest('[data-gtm-target-context]').dataset.gtmTargetContext

  const parameters = {
    event_action: target.checked ? 'add' : 'remove',
    target_text: target.value,
    target_context: targetContext,
  }

  pushToDataLayer('filter_click', parameters)
}

function trackAddToWishlist(event) {
  const product = event.detail.product
  const productPrice = isNaN(parseInt(product.price)) ? 0 : parseInt(product.price)

  const parameters = {
    currency: window.Shopify.currency.active,
    value: productPrice,
    items: [
      {
        item_id: product.id,
        item_title: product.title,
        price: productPrice,
      },
    ],
  }

  pushToDataLayer('add_to_wishlist', parameters)
}

function trackRemoveFromWishlist (event) {
  const product = event.detail.product
  const parameters = { item_title: product.title }

  pushToDataLayer('remove_from_wishlist', parameters)
}

function trackPdpGalleryClick (event) {
  const mediaIndex = event.detail?.mediaIndex || ''

  const parameters = {
    target_index: mediaIndex,
  }

  pushToDataLayer('pdp_gallery_click', parameters)
}

function trackPdpGalleryThumbClick (event) {
  const mediaIndex = event.detail?.mediaIndex || ''

  const parameters = {
    target_index: mediaIndex,
  }

  pushToDataLayer('pdp_gallery_thumbnail_click', parameters)
}

function handleNavigationClick () {
  const desktopNavItems = document.querySelectorAll('.link-menu')
  const mobileNavItems = document.querySelectorAll('.fostr-mobilemenu-link-block:not(.country-picker-wrapper) a')

  desktopNavItems.forEach((item) => {
    item.addEventListener('click', trackDesktopNavClick)
  })

  mobileNavItems.forEach((item) => {
    item.addEventListener('click', trackMobileNavClick)
  })
}

function trackDesktopNavClick (event) {
  const target = event.target
  const targetContext = target.closest('[data-gtm-target-context]').dataset.gtmTargetContext

  const parameters = {
    target_context: targetContext.trim(),
    target_text: target.textContent,
    target_url: target.href,
  }

  pushToDataLayer('desktop_navigation_click', parameters)
}

function trackMobileNavClick (event) {
  const target = event.target

  const parameters = {
    target_text: target.textContent,
    target_url: target.href,
  }

  pushToDataLayer('mobile_navigation_click', parameters)
}

function trackPDPColourChange (event) {
  const { colour } = event.detail

  const parameters = {
    target_text: colour,
  }

  pushToDataLayer('pdp_colour_change', parameters)
}

function trackPDPVariantChange (event) {
  const {
    selectedOptionName,
    selectedOptionValue,
  } = event.detail

  const parameters = {
    target_context: selectedOptionName,
    target_text: selectedOptionValue,
  }

  pushToDataLayer('pdp_variant_change', parameters)
}

function trackQuickAdd(event) {
  const parameters = {
    item_id: event.detail?.items[0]?.id,
    item_title: event.detail?.items[0]?.title,
    item_value: event.detail?.items[0]?.price,
  }

  pushToDataLayer('add_to_cart_quick_add', parameters)
}
